import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { formatAmount } from "../../../utility/CommonFunctions";
import CommonTable from "../../../components/comman/CommonTable";

const PendingPurchaseOrders = ({ siteId }) => {
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    purchaseList: [],
  });

  useEffect(() => {
    GetPurchaseList();
  }, [siteId]);

  const GetPurchaseList = () => {
    let options = {
      method: "GET",
    };

    let API =
      apiUrl.get_purchase +
      `pageNumber=1&pageSize=5&status=created${siteId ? `&siteId=${siteId}` : ""}`;

    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.purchase?.map((item) => ({
          ...item,
          purchaceRequestNumber: item?.purchaserequest?.requestNumber,
          date: moment(item?.purchaseDate).format("DD-MM-YYYY"),
          siteName: item?.purchaserequest?.site?.name,
          vendorName: item?.vendor?.name,
          totalAmounts: formatAmount(item?.totalAmount),
          purchaseRequestStatus: item?.status,
          reqType:
            item?.purchaserequest?.type === "supplyRequest"
              ? "Supply Request"
              : "Service Request",
          stockStatus:
            item?.purchaserequest?.type === "supplyRequest"
              ? item?.isAllItemReceived
              : "--",
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          purchaseList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "purchaseNumber", label: "PO No." },
    { value: "purchaceRequestNumber", label: "PR No." },
    { value: "date", label: "Date" },
    { value: "siteName", label: "Site Name" },
    { value: "vendorName", label: "Vendor" },
    { value: "reqType", label: "Type" },
    { value: "totalAmounts", label: "Total Amount" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.purchase_order_detail + `/${data?.id}`);
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  return (
    <div className="col-12 col-lg-6">
      <div className="card height-full">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending Purchase Order</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.purchase)}
            >
              View All
            </button>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.purchaseList}
            ActionData={ActionDataForPending}
            isLoading={pageStates?.tableLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingPurchaseOrders;
